// Central configuration file for API settings
export const API_URL = 'https://brand-attribute-score-backend.replit.app'
